import { ClusterCollaboratorFragment } from "@/core/graphql/graphql";
import { Column, ColumnType } from "@/shared/components/table/table.model";
import { extractProperty } from "@/utils/extract-property";
import { TemplateRef } from "@angular/core";

export const COLLABORATORS_COLUMNS: (actionsTemplateReference: TemplateRef<any>) =>
  Column<ClusterCollaboratorFragment>[] = (template: TemplateRef<any>) => [
    {
      columnId: 'userId',
      caption: 'User ID',
      fieldSelector: (c: ClusterCollaboratorFragment) => extractProperty(c.userId),
    },
    {
      columnId: 'isOwner',
      caption: 'Is Owner',
      fieldSelector: (c: ClusterCollaboratorFragment) => c.isOwner ? 'Yes' : 'No',
    },
    {
      columnId: 'status',
      caption: 'Status',
      fieldSelector: (c: ClusterCollaboratorFragment) => extractProperty(c.status),
    },
    {
      columnId: 'actions',
      caption: 'Actions',
      fieldSelector: (c: ClusterCollaboratorFragment) => extractProperty(c),
      type: ColumnType.Template,
      template: template,
    },
  ];
